/**
 * Holds additional information about a resize observer,
 * to be used internally.
 */
var ResizeObserverDetail = /** @class */ (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());
export { ResizeObserverDetail };
